import React from "react";
import { Map, Marker, GoogleApiWrapper, HeatMap } from "google-maps-react";
import locationMarkerGreen from "../../assets/location/mm_20_green.png";
import locationMarkerRed from "../../assets/location/mm_20_red.png";
import locationMarkerBlue from "../../assets/location/mm_20_blue.png";
import locationMarkerYellow from "../../assets/location/mm_20_yellow.png";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setMapOnReady } from "../../redux/actions/PPT";
class MapContainer extends React.Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     showInfoWindow: false,
  //   };
  // }

  handleMouseOver = (e) => {
    this.setState({
      showInfoWindow: true,
    });
  };
  handleMouseExit = (e) => {
    this.setState({
      showInfoWindow: false,
    });
  };
  render() {
    // const { showInfoWindow } = this.state;
    // const gradient = [
    //   "rgba(0, 255, 255, 0)",
    //   "rgba(0, 255, 255, 1)",
    //   "rgba(0, 191, 255, 1)",
    //   "rgba(0, 127, 255, 1)",
    //   "rgba(0, 63, 255, 1)",
    //   "rgba(0, 0, 255, 1)",
    //   "rgba(0, 0, 223, 1)",
    //   "rgba(0, 0, 191, 1)",
    //   "rgba(0, 0, 159, 1)",
    //   "rgba(0, 0, 127, 1)",
    //   "rgba(63, 0, 91, 1)",
    //   "rgba(127, 0, 63, 1)",
    //   "rgba(191, 0, 31, 1)",
    //   "rgba(255, 0, 0, 1)",
    // ];
    const gradient_old = [
      "rgba(0, 255, 255, 0)",
      "blue",
      "green",
      "green",
      "green",
      "green",
      "green",
      "green",
      "red",
      "red",
      "red",
      "red",
      "red",
      "red",
    ];
    // const widthLi = this.props?.refWidth
    //   ? window.innerWidth - 372
    //   : window.innerWidth - 582;
    const mapOptions = {
      geopoliticsView: "IN", // Ensures official Indian boundaries
    };

    const onReady = (mapProps, map) => {
      const timer = setTimeout(() => {
        this?.props?.onReady(true);
      }, [70000]);
      return () => {
        clearTimeout(timer);
      };
    };
    return (
      <div
        style={{
          height: this?.props?.preview
            ? "calc(100vh - 19.2rem)"
            : this?.props?.PdfDownloadStatus
            ? this?.props?.noteExist
              ? this?.props?.widgetDiscription &&
                this?.props?.widgetDiscription?.length
                ? this?.props?.widgetDiscription?.length > 130
                  ? "46rem"
                  : "48rem"
                : "50rem"
              : this?.props?.widgetDiscription &&
                this?.props?.widgetDiscription?.length
              ? this?.props?.widgetDiscription?.length > 130
                ? "64.5rem"
                : "66.5rem"
              : "68.5rem"
            : this?.props?.createdWidget && "calc(100vh - 16.5rem)",
        }}
        className={`${
          this?.props?.PdfDownloadStatus && this?.props?.noteExist
            ? "mb-10"
            : ""
        } ${this?.props?.PdfDownloadStatus ? "m-10" : ""}`}
        id="map_canvas"
      >
        <Map
          google={this?.props?.google}
          className={`map ${this?.props?.createdWidget && "position-relative"}`}
          zoom={5}
          region={this?.props?.region || "IN"}
          initialCenter={
            this?.props?.center || { lat: 19.07609, lng: 72.877426 }
          }
          onReady={(mapProps, map) => onReady(mapProps, map)}
          options={mapOptions}
          style={{
            position: "relative",
            marginLeft:
              this?.props?.preview || this?.props?.createdWidget
                ? ""
                : "-1.4rem",
            width: this?.props?.preview
              ? "auto"
              : this?.props?.createdWidget
              ? "100%"
              : "100%",
            height: this?.props?.preview
              ? "calc(100vh - 19.2rem)"
              : this?.props?.PdfDownloadStatus
              ? this?.props?.noteExist
                ? this?.props?.widgetDiscription &&
                  this?.props?.widgetDiscription?.length
                  ? this?.props?.widgetDiscription?.length > 130
                    ? "46rem"
                    : "48rem"
                  : "50rem"
                : this?.props?.widgetDiscription &&
                  this?.props?.widgetDiscription?.length
                ? this?.props?.widgetDiscription?.length > 130
                  ? "64.5rem"
                  : "66.5rem"
                : "68.5rem"
              : this?.props?.createdWidget
              ? "calc(100vh - 16.5rem)"
              : "70%",
          }}
          zoomControl={this?.props?.PdfDownloadStatus ? false : true}
          mapTypeControl={false}
          scaleControl={false}
          streetViewControl={false}
          rotateControl={false}
          panControl={true}
          fullscreenControl={this?.props?.PdfDownloadStatus ? false : true}
          zoomControlOptions={{
            position: this?.props?.google?.maps?.ControlPosition?.LEFT_BOTTOM,
          }}
          fullscreenControlOptions={{
            position: this?.props?.google?.maps?.ControlPosition?.LEFT_BOTTOM,
          }}
          mapTypeControlOptions={null}
          /**
           * gestureHandling controls how the user can interact with the map
           *
           * Available values:
           * - "auto": Default behavior. Dragging/gestures enabled on desktop,
           *           two-finger requirement on mobile inside scrollable pages
           * - "greedy": All touch gestures and scroll interactions enabled.
           *             Users can scroll and zoom without restrictions
           * - "cooperative": Map only pans/zooms with two fingers (touch) or
           *                  Ctrl/⌘ key + scroll (desktop). Prevents accidental movement (CURRENT SETTING)
           * - "none": All interactions disabled. Map becomes non-interactive
           *
           * Using "cooperative" for better user experience - prevents accidental map movement
           * when scrolling through the page, requires deliberate two-finger gestures on mobile
           * or Ctrl/⌘ key + scroll on desktop to interact with the map
           */
          gestureHandling={"cooperative"}
          styles={[
            {
              elementType: "geometry",
              stylers: [
                {
                  color: "#212121",
                },
              ],
            },
            {
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575",
                },
              ],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#212121",
                },
              ],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [
                {
                  color: "#757575",
                },
              ],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e",
                },
              ],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#bdbdbd",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#181818",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#1b1b1b",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#2c2c2c",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#8a8a8a",
                },
              ],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [
                {
                  color: "#373737",
                },
              ],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [
                {
                  color: "#3c3c3c",
                },
              ],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [
                {
                  color: "#4e4e4e",
                },
              ],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161",
                },
              ],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575",
                },
              ],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ff3c3c",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#000000",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#3d3d3d",
                },
              ],
            },
          ]}
        >
          {!this?.props?.trands && (
            <HeatMap
              gradient={gradient_old}
              positions={this?.props?.data}
              opacity={1}
              radius={20}
            />
          )}

          {this?.props?.trands &&
            this?.props?.data &&
            this?.props?.data?.map((el, i) => {
              return (
                <Marker
                  //name={'Your position'}
                  key={`this.props?.mapType_${i}`}
                  position={this?.props?.data?.[i]}
                  icon={{
                    url:
                      this?.props?.mapType === "retweet_map"
                        ? locationMarkerBlue
                        : this?.props?.sentimentType?.[i] === 2
                        ? locationMarkerRed
                        : this?.props?.sentimentType?.[i] === 1
                        ? locationMarkerGreen
                        : this?.props?.sentimentType?.[i] === 0 &&
                          locationMarkerYellow,
                    anchor: this?.props?.google?.maps
                      ? new this.props.google.maps.Point(25, 25)
                      : undefined,
                    scaledSize: this?.props?.google?.maps
                      ? new this.props.google.maps.Size(40, 40)
                      : undefined,
                  }}
                  title={this?.props?.mapCount?.[i]?.toString()}
                />
              );
            })}
        </Map>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    mapRender: state?.PPT?.mapRender,
  };
};

//Redux disptach functions
const mapDispatchToProps = (dispatch) => ({
  onReady: (value) => dispatch(setMapOnReady(value)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    GoogleApiWrapper((props) => ({
      apiKey: "AIzaSyDGqipm4Lsoq2WkGQDoH1_Iu6eXPjiuE5A",
      libraries: ["visualization"],
      //libraries: ['places', 'geometry', 'drawing', 'visualization'],
      language: props?.language,
      // Use the region passed as a prop from the parent
      region: props?.region || "IN",
    }))(MapContainer)
  )
);
